import { Card, CardContent, CardHeader, CardTitle } from "../ui/Card";

function SurveyDetailSkeleton() {
  return (
    <div className="space-y-6 animate-pulse">
      {/* Back button skeleton */}
      <div className="h-10 w-20 bg-gray-200 rounded-md"></div>

      {/* Header skeleton */}
      <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-4">
        <div className="space-y-2 flex-1">
          <div className="flex items-center gap-3 flex-wrap">
            <div className="h-8 w-64 bg-gray-200 rounded-md"></div>
            <div className="h-6 w-20 bg-gray-200 rounded-full"></div>
            <div className="h-6 w-24 bg-gray-200 rounded-full"></div>
          </div>
          <div className="h-4 w-full bg-gray-200 rounded-md"></div>
          <div className="h-4 w-3/4 bg-gray-200 rounded-md"></div>
        </div>
        <div className="flex gap-2 shrink-0 flex-wrap">
          <div className="h-10 w-24 bg-gray-200 rounded-md"></div>
          <div className="h-10 w-24 bg-gray-200 rounded-md"></div>
          <div className="h-10 w-24 bg-gray-200 rounded-md"></div>
        </div>
      </div>

      {/* Quick access cards skeleton */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {[1, 2].map((i) => (
          <Card key={i} className="shadow-card border-0">
            <CardContent className="p-5 flex items-center gap-4">
              <div className="h-12 w-12 rounded-xl bg-gray-200 flex-shrink-0"></div>
              <div className="flex-1 space-y-2">
                <div className="h-4 w-32 bg-gray-200 rounded-md"></div>
                <div className="h-3 w-48 bg-gray-200 rounded-md"></div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>

      {/* Stats skeleton */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        {[1, 2, 3, 4].map((i) => (
          <Card key={i} className="shadow-card border-0">
            <CardContent className="p-4 text-center space-y-2">
              <div className="h-8 w-12 bg-gray-200 rounded-md mx-auto"></div>
              <div className="h-3 w-20 bg-gray-200 rounded-md mx-auto"></div>
            </CardContent>
          </Card>
        ))}
      </div>

      {/* Public link skeleton */}
      <Card className="shadow-card border-0">
        <CardContent className="p-4">
          <div className="flex items-center justify-between gap-3">
            <div className="flex items-center gap-2 min-w-0 flex-1">
              <div className="h-4 w-4 bg-gray-200 rounded flex-shrink-0"></div>
              <div className="h-4 w-full bg-gray-200 rounded-md"></div>
            </div>
            <div className="h-10 w-24 bg-gray-200 rounded-md flex-shrink-0"></div>
          </div>
        </CardContent>
      </Card>

      {/* Questions and Info skeleton */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Questions */}
        <Card className="shadow-card border-0">
          <CardHeader>
            <div className="h-6 w-32 bg-gray-200 rounded-md"></div>
          </CardHeader>
          <CardContent className="space-y-3">
            {[1, 2, 3].map((i) => (
              <div key={i} className="p-3 rounded-lg bg-gray-100 space-y-2">
                <div className="h-4 w-full bg-gray-200 rounded-md"></div>
                <div className="h-4 w-3/4 bg-gray-200 rounded-md"></div>
              </div>
            ))}
          </CardContent>
        </Card>

        {/* Info */}
        <Card className="shadow-card border-0">
          <CardHeader>
            <div className="h-6 w-32 bg-gray-200 rounded-md"></div>
          </CardHeader>
          <CardContent className="space-y-3">
            {[1, 2, 3].map((i) => (
              <div key={i} className="h-4 w-full bg-gray-200 rounded-md"></div>
            ))}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}

export default SurveyDetailSkeleton;
